import { Controller } from "@hotwired/stimulus";

// Auto-dismisses a flash toast after `delayValue` ms and provides a manual
// `close` action for the dismiss button. Removing the element (rather than
// relying on a page reload) keeps the toast stack tidy during Turbo navigation.
export default class extends Controller {
  static values = { delay: { type: Number, default: 0 } };

  connect() {
    if (this.delayValue > 0) {
      this.timer = setTimeout(() => this.close(), this.delayValue);
    }
  }

  disconnect() {
    clearTimeout(this.timer);
  }

  close() {
    clearTimeout(this.timer);
    this.element.classList.add("opacity-0", "translate-x-2");
    setTimeout(() => this.element.remove(), 200);
  }
}
